import React from 'react';
import { SafeImg } from '../../SafeImg';
import { Btn, H1, Eyebrow, tidFor, E } from './_shared';

/* ════════════════════════════════════════════════════════════════════════
 * SPLIT — new variants (split-form · split-overlay)
 * Iter 175c — title · tagline · field labels · button text editable.
 * ════════════════════════════════════════════════════════════════════════ */
export function SplitExt({ block, theme, E: EProps = {} }) {
  const { onEdit } = EProps;
  const c = block.content || {};
  const layout = block.layout;

  if (layout === 'split-form') {
    const fields = c.fields || ['Name','Email','Password'];
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="grid grid-cols-1 md:grid-cols-2 min-h-[520px]" style={{ background: theme.bg, color: theme.ink }}>
        <div>{c.image_url ? <SafeImg src={c.image_url} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-violet-400 to-pink-500" />}</div>
        <div className="px-8 md:px-16 py-12 flex flex-col justify-center">
          <E block={block} onEdit={onEdit} field="title" value={c.title || 'Sign up to discover features'} tag="h2" className="text-3xl md:text-4xl font-bold leading-[1.05] tracking-tight" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
          <div className="mt-6 space-y-3 max-w-sm">
            {fields.map((f,i)=>(
              <input key={i} type={f.toLowerCase().includes('pass')?'password':'text'} placeholder={f} className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm" />
            ))}
          </div>
          <span className="mt-6 inline-block px-6 py-3 rounded-full text-sm font-bold uppercase tracking-wider text-white w-fit cursor-text" style={{ background: theme.accent || '#2DD4BF' }}>
            <E block={block} onEdit={onEdit} field="buttons.0.text" value={c.buttons?.[0]?.text || 'Sign Up'} tag="span" placeholder="Button" />
          </span>
        </div>
      </section>
    );
  }

  if (layout === 'split-overlay') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="relative px-6 py-16 overflow-hidden" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-5xl mx-auto relative">
          <div className="relative h-80">
            {c.image_url ? <SafeImg src={c.image_url} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-amber-400 to-rose-500" />}
          </div>
          <div className="md:absolute md:right-0 md:bottom-0 md:translate-y-1/2 bg-white shadow-2xl max-w-md p-8 mt-6 md:mt-0" style={{ borderRadius: theme.radius || 12 }}>
            <E block={block} onEdit={onEdit} field="title" value={c.title || 'Discounted Product of the Week'} tag="h2" className="text-2xl font-bold" style={{ fontFamily: theme.headingFont, color: theme.ink }} placeholder="Headline" />
            <E block={block} onEdit={onEdit} field="tagline" value={c.tagline || ''} tag="p" className="mt-3 text-sm opacity-70" style={{ color: theme.ink }} placeholder="Tagline" />
            <span className="mt-5 inline-block px-5 py-2.5 rounded-full text-xs font-bold uppercase text-white cursor-text" style={{ background: theme.accent || '#0E0E23' }}>
              <E block={block} onEdit={onEdit} field="buttons.0.text" value={c.buttons?.[0]?.text || 'Shop Now'} tag="span" placeholder="Button" />
            </span>
          </div>
        </div>
        <div className="md:h-24" />
      </section>
    );
  }
  return null;
}
